module.exports = __webpack_public_path__ + "img/lg_ring_g_l_0_null@2x.59975def.png";